import React, {Component} from 'react';
import {Image, Modal} from 'react-bootstrap';
import {connect} from "react-redux";
import './messageModal.css';
import iconAlert from '../../resources/images/ic-alert-modal.svg';
import iconError from '../../resources/images/ic-error-modal.svg';
import iconAlertRed from '../../resources/images/alert-icons/alert-icon-10.svg';

class MessageModal extends Component {
    getAlingButtons() {
        return this.props.alingButtons ?? "center"
    }

    render() {
        const alertType = {
            'warningRed': <Image  style={{width: '22px', height: '22px'}} src={iconAlertRed} />,
            'warning': <Image  src={iconAlert} />,
            'error': <Image src={iconError}/> 
        }
        let image = '';
        if (this.props.icon !== undefined && this.props.icon !== '') {
            const icon = require(`../../resources/images/${this.props.icon}`).default;
            image = <Image src={icon}/>;
        }
        return (
            <Modal
                show={this.props.messageModalVisibility}
                bsSize="large"
                aria-labelledby="contained-modal-title-lg"
            >
                <div className={'message-modal-content'}>
                    <Modal.Header>
                        <div className={'container-title-modal'}>
                            <span>
                                { alertType[this.props.type] || alertType['warning'] }
                            </span>
                            <Modal.Title id="contained-modal-title-lg">
                                <p>{this.props.title}</p>
                            </Modal.Title>
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        {image}

                        <p className={'principal-message'}>{this.props.principalMessage}</p>
                        {this.props.isMultipleSignature ?
                            <div className='container-secondary-message'>
                                {this.props.secondaryMessage}
                            </div> :
                            this.props.secondaryMessage
                        }
                    </Modal.Body>
                    <Modal.Footer style={{textAlign: this.getAlingButtons()}}>
                        {this.props.buttons}
                    </Modal.Footer>
                </div>
            </Modal>
        );
    }
}

const mapStateToProps = state => {
    return {
        messageModalVisibility: state.messageModalVisibility
    };
};

const mapDispatchToProps = dispatch => {
    return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(MessageModal);
